(() => {
  const giftWrapHandle = 'gift-wrap';
  const giftWrapTitle = 'gift wrap';
  const giftWrapVariantId = 53013065597237;
  const attributeName = 'Gift wrap';
  const routesRoot = window.Shopify?.routes?.root || '/';
  const cartLineSelector = '.cart-form, .cart-items__table-row, cart-item, cart-items-component, .cart-drawer__items';
  const hardStopSelector = '.resource-list, .product-grid, .collection, section, main, body';
  let isCleaningCart = false;

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function isGiftWrapItem(item) {
    if (!item) return false;
    const url = normalize(item.url);
    const handle = normalize(item.handle);
    const productHandle = normalize(item.product_handle);
    const title = normalize(item.product_title || item.title);

    return (
      item.variant_id === giftWrapVariantId ||
      handle === giftWrapHandle ||
      productHandle === giftWrapHandle ||
      url.includes(`/products/${giftWrapHandle}`) ||
      title === giftWrapTitle
    );
  }

  function getGiftWrapItems(cart) {
    return cart.items.filter(isGiftWrapItem);
  }

  function getPurchasableItemCount(cart) {
    return cart.items.reduce((count, item) => (isGiftWrapItem(item) ? count : count + item.quantity), 0);
  }

  function updateCartBubble(count) {
    document.querySelectorAll('[data-testid="cart-bubble"], .cart-bubble__text-count').forEach((element) => {
      element.textContent = count > 0 ? String(count) : '';
      element.classList.toggle('hidden', count <= 0);
    });

    document.querySelectorAll('.cart-bubble').forEach((bubble) => {
      bubble.classList.toggle('visually-hidden', count <= 0);
    });

    if (count <= 0) {
      sessionStorage.removeItem('cart-count');
    }
  }

  function isCartLineElement(element) {
    return Boolean(element.closest(cartLineSelector));
  }

  function hideElement(element) {
    if (!(element instanceof HTMLElement)) return;
    element.hidden = true;
    element.style.setProperty('display', 'none', 'important');
    element.style.setProperty('pointer-events', 'none', 'important');
    element.setAttribute('aria-hidden', 'true');
    element.querySelectorAll('a, button, input').forEach((control) => {
      control.setAttribute('tabindex', '-1');
      control.setAttribute('aria-hidden', 'true');
      if ('disabled' in control) control.disabled = true;
    });
  }

  function scoreCandidate(element) {
    const rect = element.getBoundingClientRect();
    const className = String(element.className || '').toLowerCase();
    let score = 0;

    if (className.includes('resource-list__item')) score += 8;
    if (className.includes('product-card')) score += 7;
    if (element.tagName.toLowerCase() === 'product-card') score += 7;
    if (element.matches('li, article')) score += 5;
    if (element.querySelector?.(`a[href*="/products/${giftWrapHandle}"]`)) score += 4;
    if (rect.width > 120 && rect.height > 120) score += 3;
    if (rect.width > window.innerWidth * 0.9 || rect.height > window.innerHeight * 0.9) score -= 20;

    return score;
  }

  function findGiftWrapCard(element) {
    let current = element instanceof HTMLElement ? element : element.parentElement;
    let best = current;
    let bestScore = -Infinity;

    while (current && current.parentElement && !current.matches(hardStopSelector)) {
      const score = scoreCandidate(current);
      if (score >= bestScore) {
        best = current;
        bestScore = score;
      }
      current = current.parentElement;
    }

    return best;
  }

  function hideGiftWrapCardFromElement(element) {
    if (isCartLineElement(element)) return;
    hideElement(findGiftWrapCard(element));
  }

  function hideGiftWrapMerchandising() {
    document.querySelectorAll(`a[href*="/products/${giftWrapHandle}"]`).forEach(hideGiftWrapCardFromElement);

    document.querySelectorAll('a, h1, h2, h3, h4, p, span, .product-title, .card__heading, [class*="title"]').forEach((element) => {
      if (normalize(element.textContent) !== giftWrapTitle) return;
      hideGiftWrapCardFromElement(element);
    });
  }

  function redirectGiftWrapProductPage() {
    const path = window.location.pathname.replace(/\/$/, '');
    if (!path.endsWith(`/products/${giftWrapHandle}`)) return;

    window.location.replace(`${routesRoot}cart`);
  }

  function isGiftWrapRow(row) {
    if (!(row instanceof HTMLElement)) return false;
    if (row.dataset.giftWrapLine === 'true') return true;
    if (row.querySelector(`a[href*="/products/${giftWrapHandle}"]`)) return true;
    if (row.querySelector(`[data-variant-id="${giftWrapVariantId}"]`)) return true;

    const title = row.querySelector('.cart-items__title, [class*="title"]');
    return normalize(title?.textContent) === giftWrapTitle;
  }

  function getCartRows() {
    return Array.from(document.querySelectorAll('cart-items-component .cart-items__table-row')).filter(
      (row) => row instanceof HTMLElement
    );
  }

  function getGiftWrapRows() {
    return getCartRows().filter(isGiftWrapRow);
  }

  function getPurchasableRows() {
    return getCartRows().filter((row) => !isGiftWrapRow(row));
  }

  function hideRows(rows) {
    rows.forEach((row) => hideElement(row));
  }

  async function getCart() {
    const response = await fetch(`${routesRoot}cart.js`, {
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) throw new Error('Could not load cart');
    return response.json();
  }

  async function removeGiftWrapItems(giftWrapItems) {
    await Promise.all(
      giftWrapItems.map((item) =>
        fetch(`${routesRoot}cart/change.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ id: item.key, quantity: 0 }),
        }).then((response) => {
          if (!response.ok) throw new Error('Could not remove gift wrapping');
        })
      )
    );

    const updateResponse = await fetch(`${routesRoot}cart/update.js`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ attributes: { [attributeName]: '' } }),
    });

    if (!updateResponse.ok) throw new Error('Could not clear gift wrap attribute');
  }

  async function cleanStaleGiftWrap(options = {}) {
    if (isCleaningCart) return;
    isCleaningCart = true;

    try {
      const cart = await getCart();
      const giftWrapItems = getGiftWrapItems(cart);
      const purchasableItemCount = getPurchasableItemCount(cart);

      updateCartBubble(purchasableItemCount);

      if (!giftWrapItems.length || purchasableItemCount > 0) return;

      updateCartBubble(0);
      hideRows(getGiftWrapRows());
      await removeGiftWrapItems(giftWrapItems);

      if (options.reload !== false) {
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
    } finally {
      isCleaningCart = false;
    }
  }

  function handlePossibleLastPurchasableRemoval(row) {
    if (!(row instanceof HTMLElement) || isGiftWrapRow(row)) return;

    const purchasableRows = getPurchasableRows();
    if (purchasableRows.length !== 1 || purchasableRows[0] !== row) return;

    hideRows(getGiftWrapRows());
    updateCartBubble(0);
    setTimeout(cleanStaleGiftWrap, 80);
    setTimeout(cleanStaleGiftWrap, 250);
  }

  function watchCartRemovalActions() {
    document.addEventListener(
      'click',
      (event) => {
        const removeButton = event.target instanceof Element ? event.target.closest('.cart-items__remove') : null;
        const row = removeButton?.closest('.cart-items__table-row');
        handlePossibleLastPurchasableRemoval(row);
      },
      true
    );

    document.addEventListener(
      'quantity-selector:update',
      (event) => {
        if (event.detail?.quantity !== 0) return;
        const row = event.target instanceof Element ? event.target.closest('.cart-items__table-row') : null;
        handlePossibleLastPurchasableRemoval(row);
      },
      true
    );
  }

  function initialize() {
    hideGiftWrapMerchandising();
    cleanStaleGiftWrap();
  }

  redirectGiftWrapProductPage();
  watchCartRemovalActions();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  document.addEventListener('cart:update', cleanStaleGiftWrap);
  document.addEventListener('cart-update', cleanStaleGiftWrap);
  window.addEventListener('pageshow', cleanStaleGiftWrap);

  new MutationObserver(hideGiftWrapMerchandising).observe(document.documentElement, { childList: true, subtree: true });
})();
